export function getFullPath(path: string): string {
  const router = useRouter()
  const route = router.resolve(path)
  return new URL(route.href, window.location.origin + window.location.pathname).href
}
